import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export const ProtectedRoute = ({ children }) => {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div data-testid="auth-checking" className="flex min-h-[60vh] items-center justify-center text-sm text-[#F7F1E8]/68">
        <span className="animate-pulse">Se deschide ușa clasei&hellip;</span>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
};

export default ProtectedRoute;
